export function encodeBase64Url(input) {
  return toBase64Url(encodeBase64(input));
}
export function decodeBase64Url(input) {
  return decodeBase64(fromBase64Url(input));
}
export function decodeBase64(input) {
  return JSON.parse(try2(decode, atob, input));
}
export function encodeBase64(input) {
  return encode(JSON.stringify(input));
}
function toBase64Url(base64) {
  return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function fromBase64Url(base64url) {
  return base64url.replace(/-/g, '+').replace(/_/g, '/');
}
function encode(str) {
  return btoa(encodeURIComponent(str).replace(/%[0-9A-F]{2}/g, percentToByte));
}
function decode(str) {
  return decodeURIComponent(Array.from(atob(str), byteToPercent).join(''));
}
function percentToByte(p) {
  return String.fromCharCode(parseInt(p.slice(1), 16));
}
function byteToPercent(b) {
  return `%${`00${b.charCodeAt(0).toString(16)}`.slice(-2)}`;
}
function try2(f1, f2) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  try {
    return f1(...args);
  } catch {
    return f2(...args);
  }
}
//# sourceMappingURL=encode-base64.js.map